import ProjectFeedScreen from '../../../../components/digest/ProjectFeedScreen';
import { withProjectProvider } from '../../../../components/withProjectProvider';

export default withProjectProvider(ProjectFeedScreen);
